export const nationalityKeys = {
  all: ['nationalities'],
  list: (params: any) => ['nationalities', 'list', params],
  detail: (id: any) => ['nationalities', 'detail', id],
};
